<template>
    <el-dialog title="关联值域" width="40%" :close-on-click-modal="false" append-to-body :visible.sync="visible">
        <el-form size="small" :model="form" ref="form" v-loading="loading" @keyup.enter.native="doSubmit()"
                 @submit.native.prevent>
            <el-descriptions title="选项设置"></el-descriptions>
            <el-form-item prop="basicForAddRang">
                <el-checkbox v-model="form.basicForAddRang" true-label="0" false-label="1">允许成员填写时添加新选项</el-checkbox>
            </el-form-item>
            <el-descriptions title="值域设置"></el-descriptions>
            <el-form-item label="值域：" :rules="[{required: true}]">
                <el-link class="m_r1 addBtn" type="primary" @click="add()">添加选项</el-link>
                <el-dropdown>
                    <el-link class=" addBtn" type="primary">批量修改</el-link>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="edit()">直接添加</el-dropdown-item>
                        <el-dropdown-item @click.native="rangeLibrary()">从语义库同步</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </el-form-item>
            <div class="rangeBox">
                <draggable v-model="form.basicRangeList" element="tbody" class="block"
                           :options="{animation: 150, handle: '.allowDrag'}">
                    <div v-for="(item, index) in form.basicRangeList" :key="index">
                        <el-form-item :prop="`basicRangeList.${index}.basicRange`" label-width="65px"
                                      :rules="[{required: true, pattern: '[^ \x20]+', message: '值域不能为空', trigger: 'blur'}]">
                            <div class="flex_l_c">
                                <el-input v-model.trim="item.basicRange" placeholder="请输入值域（限10字）" clearable
                                          maxlength="10"></el-input>
                                <el-link icon="el-icon-rank" class="allowDrag m_l1" :underline="false"></el-link>
                                <el-link :underline="false" type="primary" class="el-icon-delete m_l1"
                                         @click="del(index)"></el-link>
                            </div>
                        </el-form-item>
                    </div>
                </draggable>
            </div>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>确定</el-button>
        </div>
        <el-dialog width="20%" :close-on-click-modal="false" append-to-body :visible.sync="editVisible">
            <div slot="title" class="flex_l_c">
                <div class="el-dialog__title">批量添加值域</div>
                <el-tooltip class="item" effect="dark" content="每一行算一个单独值域" placement="right">
                    <div class="el-icon-question"></div>
                </el-tooltip>
            </div>
            <el-input class="textarea" v-model="ranges" type="textarea" :rows="10" placeholder="请输入"
                      maxlength="1000"></el-input>
            <div slot="footer">
                <el-button size="small" @click="editVisible = false">取消</el-button>
                <el-button size="small" type="primary" @click="confirm()" v-noMoreClick>确定</el-button>
            </div>
        </el-dialog>
        <RangeLibrary ref="rangeLibrary" @getRangeLibrary="getRangeLibrary"></RangeLibrary>
    </el-dialog>
</template>

<script>
    import draggable from "vuedraggable";
    import RangeLibrary from './rangeLibrary'

    export default {
        components: {draggable, RangeLibrary},
        data() {
            return {
                visible: false,
                loading: false,
                basicId: '',
                form: {
                    basicForAddRang: '1',
                    basicRangeList: [],
                },
                // 修改
                editVisible: false,
                ranges: '',
            }
        },
        methods: {
            init(id) {
                this.form.basicRangeList = []
                this.visible = true
                this.basicId = id
                this.$nextTick(() => {
                    this.$refs.form.resetFields();
                    this.getInfo()
                })
            },
            // 获取详情信息
            getInfo() {
                this.loading = true
                this.$axios(this.api.metadata.getById + '/' + this.basicId).then(res => {
                    if (res.status) {
                        this.form = this.recover(this.form, res.data);
                    }
                    this.loading = false
                })
            },
            // 添加选项
            add() {
                if (this.form.basicRangeList.length >= 100) {
                    this.$message.warning('最多添加100个选项');
                    return
                }
                this.form.basicRangeList.push({basicRange: '', sorts: this.form.basicRangeList.length + 1})
            },
            // 批量修改
            edit() {
                this.ranges = ''
                this.form.basicRangeList.map(item => {
                    if (item.basicRange.trim()) {
                        this.ranges += item.basicRange + '\n'
                    }
                })
                this.editVisible = true
            },
            // 从语义库同步
            rangeLibrary() {
                this.$refs.rangeLibrary.init(this.form.basicRangeList)
            },
            // 确定修改
            confirm() {
                let arr = this.ranges.split('\n'), list = [], flag = true
                if (arr.length > 100) {
                    this.$message.warning('最多添加100个选项')
                    return
                }
                arr.map((item, index) => {
                    if (item.trim().length > 10) {
                        flag = false
                        this.$message.error('第' + (index + 1) + '项值域长度大于10个字符')
                    }
                    if (flag && item.trim()) {
                        list.push({
                            basicRange: item.trim(),
                            sort: index + 1
                        })
                    }
                })
                this.$nextTick(() => {
                    if (flag) {
                        this.form.basicRangeList = list
                        this.editVisible = false
                    }
                })
            },
            // 删除
            del(index) {
                this.$confirm(`确定删除所选项吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.form.basicRangeList.splice(index, 1);
                })
            },
            isRepeat(arr) {
                let repeat = [];
                var hash = {};
                for (let item = 0; item < arr.length; item++) {
                    if (hash[arr[item].basicRange]) { //如果有重复则进去该判断
                        repeat.push(arr[item].basicRange) //将重复项加到数组中用于提示
                    } else {
                        hash[arr[item].basicRange] = true;
                    }
                }
                return repeat;
            },
            // 获取语义库选择的数据
            getRangeLibrary(val) {
                this.form.basicRangeList = val || []
            },
            // 确定
            doSubmit() {
                if (!this.form.basicRangeList.length) {
                    this.$message.warning('请添加值域选项')
                    return
                }
                if (this.isRepeat(this.form.basicRangeList).length) {
                    this.$message.warning('值域选项不能重复')
                    return
                }
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.loading = true
                        this.$axios(this.api.metadata.metadatarangeSave, {basicId: this.basicId, ...this.form}, 'post').then(data => {
                            if (data.status) {
                                this.$message.success('操作成功')
                                this.visible = false
                                this.$emit('refreshDataList')
                            } else {
                                this.$message.error(data.msg)
                            }
                            this.loading = false
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .el-icon-question {
        margin-left: 6px;
        font-size: 16px;
        cursor: pointer;
    }

    .textarea {
        white-space: pre-wrap;
    }

    .rangeBox {
        max-height: calc(100vh - 372px);
        overflow-y: auto;
        padding-right: 10px;
    }

    .addBtn {
        font-size: 12px !important;
        margin-bottom: 2px;
    }

</style>
